import { useRef, useState } from 'react'
import {
  downloadStationOperationsCsv,
  StationOperationsCsvRow,
} from 'BoostXpressAdmin/Utils/stationOperationsExport'
import { stationOperationsError } from 'BoostXpressAdmin/Utils/stationOperations'

export function useStationOperationsExport() {
  const [isExporting, setIsExporting] = useState(false)
  const [exportError, setExportError] = useState('')
  const inFlight = useRef(false)

  const exportCsv = async <T>(
    load: () => T[] | Promise<T[]>,
    mapRow: (item: T) => StationOperationsCsvRow,
    filename: string,
  ) => {
    if (inFlight.current) return
    inFlight.current = true
    setIsExporting(true)
    setExportError('')
    try {
      const rows = await load()
      if (!rows.length) throw new Error('No matching records to export.')
      downloadStationOperationsCsv(rows.map(mapRow), filename)
    } catch (error) {
      setExportError(stationOperationsError(error))
    } finally {
      inFlight.current = false
      setIsExporting(false)
    }
  }

  return { exportCsv, isExporting, exportError }
}
